import type { PresenceUser } from "../types";

export const NATO_CALLSIGNS = [
  "Alpha",
  "Bravo",
  "Charlie",
  "Delta",
  "Echo",
  "Foxtrot",
  "Golf",
  "Hotel",
  "India",
  "Juliett",
  "Kilo",
  "Lima",
  "Mike",
  "November",
  "Oscar",
  "Papa",
  "Quebec",
  "Romeo",
  "Sierra",
  "Tango",
  "Uniform",
  "Victor",
  "Whiskey",
  "Xray",
  "Yankee",
  "Zulu"
];

export const normalizeCallsign = (value: string) =>
  value.trim().split(/\s+/)[0] ?? "";

export const canonicalizeCallsign = (value: string) =>
  normalizeCallsign(value).toLowerCase();

const toUsedCallsigns = (presence: PresenceUser[], currentUserId?: string) => {
  const used = new Set<string>();
  presence.forEach((entry) => {
    if (currentUserId && entry.userId === currentUserId) {
      return;
    }
    const normalized = canonicalizeCallsign(entry.callsign);
    if (normalized) {
      used.add(normalized);
    }
  });
  return used;
};

export const isCallsignTaken = (
  value: string,
  presence: PresenceUser[],
  currentUserId?: string
) => {
  const normalized = canonicalizeCallsign(value);
  if (!normalized) return false;
  return toUsedCallsigns(presence, currentUserId).has(normalized);
};

export const firstAvailableNatoCallsign = (
  presence: PresenceUser[],
  currentUserId?: string
) => {
  const used = toUsedCallsigns(presence, currentUserId);
  return NATO_CALLSIGNS.find((candidate) => !used.has(candidate.toLowerCase())) ?? "";
};

export const resolveInitialCallsignDraft = (
  storedCallsign: string | null,
  presence: PresenceUser[],
  currentUserId?: string
) => {
  const normalizedStored = normalizeCallsign(storedCallsign ?? "");
  if (normalizedStored) {
    return {
      value: normalizedStored,
      conflict: isCallsignTaken(normalizedStored, presence, currentUserId)
    };
  }
  return {
    value: firstAvailableNatoCallsign(presence, currentUserId),
    conflict: false
  };
};
